import React, { useState } from "react";
import './CreateFPS.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
const CreateFPS = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [licenceNumber, setLicenceNumber] = useState("");
    const [mobileNum, setMobileNum] = useState("");
    const [fpsId, setFPSID] = useState("");
    const [taggedFpsId, setTaggedFPSID] = useState("");
    const [epdsCode, setEPSDCode] = useState("");
    const [fpsOperatingBy, setOperating] = useState('');
    const [showCalendar, setShowCalendar] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [showTaggedCalendar, setShowTaggedCalendar] = useState(false);
    const [taggedDate, setTaggedDate] = useState(null);
    const [dealerName, setDealerName] = useState('');
    const [fpsNomineeName, setNomine] = useState('');
    const [fpsAddress1, setAddressF] = useState('');
    const [fpsAddress2, setAddressS] = useState('');
    const [isTagged, setIsTagged] = useState('');
    const [fpsNomineeStatus, setNomineStatus] = useState('');
    const [currentStatus, setCurrentStatus] = useState('');
    // Handle input change
    const handleChange = (e) => {
        const value = e.target.value;

        // Regex to allow only numbers and one decimal point
        const regex = /^\d*\.?\d*$/;

        if (value === "" || regex.test(value)) {
            setLatitude(value);
        }
    };

    // Handle input change
    const handleChange1 = (e) => {
        const value = e.target.value;

        // Regex to allow only numbers and one decimal point
        const regex = /^\d*\.?\d*$/;

        if (value === "" || regex.test(value)) {
            setLongitude(value);
        }
    };


    const handleChange2 = (e) => {
        const value = e.target.value;

        // Regex to allow only numeric characters (0-9) and the '/' character
        const regex = /^[0-9/]*$/;

        if (value === "" || regex.test(value)) {
            setLicenceNumber(value);
        }
    };

    // Handle input change
    const handleChange3 = (e) => {
        const value = e.target.value;

        // Regex to allow only numeric characters (0-9)
        const regex = /^[0-9]*$/;

        if (value === "" || regex.test(value)) {
            setMobileNum(value);
        }
    };
    // Handle input change
    const handleChange4 = (e) => {
        const value = e.target.value;

        // Regex to allow only numeric characters (0-9)
        const regex = /^[0-9]*$/;

        if (value === "" || regex.test(value)) {
            setFPSID(value);
        }
    };
    // Handle input change
    const handleChange5 = (e) => {
        const value = e.target.value;

        // Regex to allow only numeric characters (0-9)
        const regex = /^[0-9]*$/;

        if (value === "" || regex.test(value)) {
            setTaggedFPSID(value);
        }
    };
    // Handle input change
    const handleChange6 = (e) => {
        const value = e.target.value;

        // Regex to allow only numeric characters (0-9)
        const regex = /^[0-9]*$/;

        if (value === "" || regex.test(value)) {
            setEPSDCode(value);
        }
    };
    // Cancel button handler
    const handleCancelButtonClick = () => {
        navigate('/');
    };

    const handleStartDateChange = (date) => {
        setStartDate(date); // Set the selected start date
        setShowCalendar(false); // Hide the start date calendar after selection
        //   setShowEndCalendar(false); // Hide the end date calendar
    };
    const handleTaggedOnDate = (date) => {
        setTaggedDate(date); // Set the selected start date
        setShowTaggedCalendar(false); // Hide the start date calendar after selection
        //   setShowEndCalendar(false); // Hide the end date calendar
    };

    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent the default form submission

        const payload = {
            email,
            latitude,
            longitude,
            licenceNumber,
            mobileNum,
            fpsId,
            dealerName,
            taggedFpsId,
            epdsCode,
            fpsOperatingBy,
            fpsAddress1,
            fpsAddress2,
            fpsNomineeName,
            isTagged: isTagged.charAt(0),
            currentStatus: currentStatus.charAt(0),
            fpsNomineeStatus: fpsNomineeStatus,
            validity: startDate ? format(startDate, 'yyyy-MM-dd') : '',
            taggedOn: taggedDate ? format(taggedDate, 'yyyy-MM-dd') : '',
        };

        //console.log("Form Payload:", payload);

        // Send data using axios or fetch
        axios.post(`${baseUrl}/createFps`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                // console.log("Response from API:", response);
                // Clear form after submission
                setEmail('');
                setLatitude('');
                setLongitude('');
                setLicenceNumber('');
                setMobileNum('');
                setFPSID('');
                setTaggedFPSID('');
                setEPSDCode('');
                setOperating('');
                setAddressF('');
                setAddressS('');
                setNomine('');
                setIsTagged('');
                setCurrentStatus('');
                setNomineStatus('');
                setStartDate('');
                setTaggedDate('');

                navigate('/');
            })
            .catch((error) => {
                console.error("Error during API call:", error);
                // Handle error here
            });
    };


    return (
        <div className="create-fps-container">
            {/* <h2 className="form-title">Create User</h2> */}
            <div className="createFps-card">
                <div className="createFps-card-header">Create FPS</div>
                <form className="fps-body" onSubmit={handleSubmit}>
                    <div className="fps-group-cu">
                        <label className="cre-text-1" htmlFor="validate">Validate</label>
                        <div className="create-fps">
                            <input
                                type="text"
                                id="startDate"
                                className="create-fps-input-repo"
                                value={startDate ? format(startDate, 'dd-MM-yyyy') : ''}
                                readOnly
                                onClick={() => setShowCalendar(true)}
                            />
                            <div className="create-fps-icon-test-stock-repo" onClick={() => setShowCalendar(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                    <path d="M7 10l5 5 5-5z" />
                                </svg>
                            </div>
                            {showCalendar && (
                                <DatePicker
                                    selected={startDate}
                                    onChange={handleStartDateChange}
                                    onClickOutside={() => setShowCalendar(false)}
                                    inline
                                />
                            )}
                        </div>

                    </div>

                    <div className="fps-group-cu">
                        <label className="cre-text-5" htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter Email"
                            required
                        />
                    </div>

                    <div className="fps-group-cu">
                        <label className="cre-text-2" htmlFor="latitude">Latitude</label>
                        <input
                            type="text"
                            id="latitude"
                            value={latitude}
                            required
                            onChange={handleChange}
                            placeholder="Enter Latitude Number"
                        />
                    </div>



                    <div className="fps-group-cu">
                        <label className="cre-text-2" htmlFor="longitude">Longitude</label>
                        <input
                            type="text"
                            id="longitude"
                            required
                            value={longitude}
                            onChange={handleChange1}
                            placeholder="Enter Longitude Number"
                        />
                    </div>

                    <div className="fps-group-cu">
                        <label className="cre-text-3" htmlFor="licenceNumber">Licence Number</label>
                        <input
                            type="text"
                            id="licenceNumber"
                            value={licenceNumber}
                            required
                            onChange={handleChange2}
                            placeholder="Enter Licence Number"
                        />
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-3" htmlFor="dealerName">Dealer Name</label>
                        <input
                            type="text"
                            id="dealerName"
                            required
                            value={dealerName}
                            onChange={(e) => setDealerName(e.target.value)}
                            placeholder="Enter Dealer Name"
                        />
                    </div>

                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="isTagged">isTagged</label>
                        <select
                            value={isTagged} // Bind the select value to the state
                            onChange={(e) => setIsTagged(e.target.value)} // Set the state to first letter of the selected value
                        >
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>



                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="mobileNum">Mobile Number</label>
                        <input
                            type="text"
                            value={mobileNum}
                            id="mobileNum"
                            required
                            onChange={handleChange3}
                            placeholder="Enter Mobile Number"
                        />
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="currentStatus">Current Status</label>
                        <select
                            value={currentStatus} // Bind the select value to the state
                            onChange={(e) => setCurrentStatus(e.target.value)} // Set the state to first letter of the selected value
                        >
                            <option >Select</option>
                            <option>Accept</option>
                            <option>Cancel</option>
                            <option>Denied</option>
                            <option>Suspend</option>
                        </select>
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="fPSID">FPS ID</label>
                        <input
                            type="text"
                            id="fPSID"
                            required
                            value={fpsId}
                            onChange={handleChange4}
                            placeholder="Enter FPS ID"
                        />
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="taggedOn">Tagged On</label>
                        <div className="create-fps">
                            <input
                                type="text"
                                id="startDate"
                                className="create-fps-input-repo"
                                value={taggedDate ? format(taggedDate, 'dd-MM-yyyy') : ''}
                                readOnly
                                onClick={() => setShowTaggedCalendar(true)}
                            />
                            <div className="create-fps-icon-test-stock-repo" onClick={() => setShowTaggedCalendar(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                    <path d="M7 10l5 5 5-5z" />
                                </svg>
                            </div>
                            {showTaggedCalendar && (
                                <DatePicker
                                    selected={taggedDate}
                                    onChange={handleTaggedOnDate}
                                    onClickOutside={() => setShowTaggedCalendar(false)}
                                    inline
                                // minDate={minStartDate} // From January 1st of current year
                                // maxDate={currentDate} // Today
                                />
                            )}
                        </div>
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="TaggedFPSID">Tagged FPSID</label>
                        <input
                            type="text"
                            id="TaggedFPSID"
                            required
                            value={taggedFpsId}
                            onChange={handleChange5}
                            placeholder="Enter Tagged FPSID"
                        />
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="FpsAddress1">Fps Address1</label>
                        <input
                            type="text"
                            id="FpsAddress1"
                            required
                            value={fpsAddress1}
                            onChange={(e) => setAddressF(e.target.value)}
                            placeholder="Enter Fps Address1"
                        />
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="fpsAddress2">Fps Address2</label>
                        <input
                            type="text"
                            id="fpsAddress2"
                            required
                            value={fpsAddress2}
                            onChange={(e) => setAddressS(e.target.value)}
                            placeholder="Enter Fps Address2"
                        />
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="fpsNomineeStatus">Fps Nominee Status</label>
                        <select
                            value={fpsNomineeStatus} // Bind the select value to the state
                            onChange={(e) => setNomineStatus(e.target.value)} // Set the state to first letter of the selected value
                        >
                            <option >Select</option>
                            <option>Yes</option>
                            <option>No</option>
                        </select>
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="FpsNomineeName">Fps Nominee Name</label>
                        <input
                            type="text"
                            id="FpsNomineeName"
                            required
                            value={fpsNomineeName}
                            onChange={(e) => setNomine(e.target.value)}
                            placeholder="Enter Fps Nominee Name"
                        />
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="FpsOperatingBy">Fps OperatingBy</label>
                        <input
                            type="text"
                            id="FpsOperatingBy"
                            required
                            value={fpsOperatingBy}
                            onChange={(e) => setOperating(e.target.value)}
                            placeholder="Enter Fps Nominee OperatingBy"
                        />
                    </div>
                    <div className="fps-group-cu">
                        <label className="cre-text-6" htmlFor="EPDSCode">EPDS Code</label>
                        <input
                            type="text"
                            id="EPDSCode"
                            required
                            value={epdsCode}
                            onChange={handleChange6}
                            placeholder="Enter EPDS Code"
                        />
                    </div>
                    <div className="createFpsButtons">
                        <button className="createFps-btn">Create FPS</button>
                        <button className="btn-createFps" onClick={handleCancelButtonClick}>CANCEL</button>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default CreateFPS;
